import { getRoleConfig } from '../service/access-roles/service';
import { RoleConfigActionsMapInterface } from '../store';
import { HandleUpdateRoleConfigInterface } from './types';

export const DECLARATION_CONSTANTS: Record<string, string> = {
  NO_RESPONSE_ERROR_MESSAGE: 'Something Went Wrong!!',
};

export const handleUpdateRoleConfig: HandleUpdateRoleConfigInterface = async ({
  setRoleConfig,
  setRoleConfigTags,
  setConfigs,
  setRoleConfigActions,
  setRoleConfigAllowedSites,
  setAllowTenantSiteSelection,
  isLoggedIn,
}) => {
  const resetConfig = () => {
    setRoleConfig(null);
    setRoleConfigTags(null);
    setConfigs(null);
    setAllowTenantSiteSelection(false);
    setRoleConfigActions(null);
  };

  if (!isLoggedIn) {
    resetConfig();
    return;
  }

  try {
    const response = await getRoleConfig();
    if (!response)
      throw new Error(DECLARATION_CONSTANTS.NO_RESPONSE_ERROR_MESSAGE);

    const { moduleConfigResponseMap, tags, allowedSites, configs } = response;
    setRoleConfig(moduleConfigResponseMap);
    setRoleConfigTags(tags);
    setConfigs(configs);
    setAllowTenantSiteSelection(
      !!configs?.find((item: any) => item?.key === 'SITE_SELECTION_REQUIRED')
        ?.value,
    );
    setRoleConfigAllowedSites(allowedSites);

    const roleConfigActions = Object.values(moduleConfigResponseMap ?? {})
      .flatMap((config) => Object.values(config?.actions ?? {}))
      .reduce((result: RoleConfigActionsMapInterface, actionItem) => {
        if (actionItem) {
          result[actionItem.actionId] = actionItem;
        }
        return result;
      }, {});

    setRoleConfigActions(roleConfigActions);
  } catch (error) {
    console.error(error);
    resetConfig();
  }
};
